import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { Integration } from "@/models/Integration";
import { IntegrationStatus } from "@/types/IntegrationStatus";

class MergeIntegrationService {
  private basePath: string;

  constructor(basePath: string) {
    this.basePath = basePath;
  }

  async getLinkToken(tenantExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.get(`${this.basePath}/token?tenantExternalId=${tenantExternalId}`);
  }

  async createIntegration(publicToken: string, tenantExternalId: string): Promise<ApiResponseV2<Integration>> {
    return HttpClientV2.post(`${this.basePath}/`, {
      publicToken: publicToken,
      tenantExternalId: tenantExternalId,
    });
  }

  async getStatus(): Promise<ApiResponseV2<IntegrationStatus>> {
    return HttpClientV2.get(`${this.basePath}/status`);
  }

  async mergeIntegrationHasFinished(integrationExternalId: string): Promise<ApiResponseV2<boolean>> {
    return HttpClientV2.get(`${this.basePath}/has-finished?integrationExternalId=${integrationExternalId}`);
  }

  async getIntegrations(tenantExternalId: string): Promise<ApiResponseV2<Integration[]>> {
    return HttpClientV2.get(`${this.basePath}?tenantExternalId=${tenantExternalId}`);
  }

  async deleteIntegration(externalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.delete(`${this.basePath}/${externalId}`);
  }

  async getLastSyncDate(): Promise<ApiResponseV2<string>> {
    return HttpClientV2.get(`${this.basePath}/last-sync`);
  }
}

export default new MergeIntegrationService("/api/merge");
